import { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK } from '../../constants';
import { getLocalizedString } from '../../utils/i18n-utils';
import Link from '../common/Link';
import MutedText from '../common/MutedText';
import { useWidgetContext } from '../context/WidgetContext';

export default function TermsContainer() {
  const { settings } = useWidgetContext();
  const displayName = settings.displayName;
  const showTermsTextDescription = `${getLocalizedString('primaryauth.tandcstart')} ${displayName} ${getLocalizedString('primaryauth.tandcend')}`;
  const tAndCEnd = '.';
  if (settings.newUser) {
    return (
      <div className="fe_u_margin--bottom-large">
        {settings.showTermsText ? (
          <MutedText text={showTermsTextDescription} />
        ) : (
          <>
            <MutedText className="terms-container-item" text={getLocalizedString('password.create.tandcstart')} />
            <Link
              className="terms-container-item"
              target="_blank"
              href={TERMS_OF_USE_LINK}
              text={getLocalizedString('footer.termsofuse')}
            />
            <MutedText className="terms-container-item" text={getLocalizedString('and')} />
            <Link
              className="terms-container-item fe_u_margin--right-none fe_u_padding--right-none"
              target="_blank"
              href={PRIVACY_POLICY_LINK}
              text={getLocalizedString('footer.privacy')}
            />
            <MutedText className="terms-container-item" text={tAndCEnd} />
          </>
        )}
      </div>
    );
  }
  return <></>;
}
